import { setFirewallValues, switchFirewallFormVisible } from '../actions';
import { setItemValueByType } from '../../utils/arraySetters';
import { SERVICE_TYPE } from '../../constants';

export const firewallReducer = {
  [setFirewallValues]: (state, { payload: { ...value } }) => ({ ...state,
    extraServices: setItemValueByType(SERVICE_TYPE.firewall, {
      list: state.extraServices,
      value,
    }) }),
  [switchFirewallFormVisible]: (state) => ({ ...state, isFirewallFormVisible: !state.isFirewallFormVisible }),
};
